import { render, staticRenderFns } from "./CRUDEquipes.vue?vue&type=template&id=3df8eed1&"
import script from "./CRUDEquipes.vue?vue&type=script&lang=js&"
export * from "./CRUDEquipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports